var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.model.basicInformation
        ? _c("text-label-row", {
            attrs: {
              title:
                "Notification.InspectionVisitNotification.BasicInformation",
              bold: true,
              value: _vm.model.basicInformation
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.model.goalScopeAndRestrictions
        ? _c("text-label-row", {
            attrs: {
              title:
                "Notification.InspectionVisitNotification.GoalScopeAndRestrictions",
              bold: true,
              value: _vm.model.goalScopeAndRestrictions
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.model.preparations
        ? _c("text-label-row", {
            attrs: {
              title: "Notification.InspectionVisitNotification.Preparations",
              bold: true,
              value: _vm.model.preparations
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.model.inspectionReportAndAnswer
        ? _c("text-label-row", {
            attrs: {
              title:
                "Notification.InspectionVisitNotification.InspectionReportAndAnswer",
              bold: true,
              value: _vm.model.inspectionReportAndAnswer
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.model.inspectionRight
        ? _c("text-label-row", {
            attrs: {
              title: "Notification.InspectionVisitNotification.InspectionRight",
              bold: true,
              value: _vm.model.inspectionRight
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }